import { render, staticRenderFns } from "./FixedAgentCard.vue?vue&type=template&id=ab244f46&scoped=true&"
import script from "./FixedAgentCard.vue?vue&type=script&lang=js&"
export * from "./FixedAgentCard.vue?vue&type=script&lang=js&"
import style0 from "./FixedAgentCard.vue?vue&type=style&index=0&id=ab244f46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab244f46",
  null
  
)

export default component.exports